const state = {

  /** Array email clients */
    emails : [] ,

}
const mutations = {

  /** Definir l'user */
  ADD_EMAIL(state, payload) {
  
    state.emails.push(payload) ;
  },
  /** Suppression d'un email */
  REMOVE_EMAIL(state, payload) {
  
    // look for payload in emails and remove it
    const objWithIdIndex = state.emails.findIndex((obj) => obj === payload);
    if (objWithIdIndex > -1) {
      state.emails.splice(objWithIdIndex, 1);
    }
   },
   /** Suppression array user */
   REMOVE_EMAILS(state) {
    state.emails = [];
},

}
export default {
    state,
    mutations,
}